import { SharedModule } from 'src/app/shared/shared.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import * as fromAgreement from '../agreement/agreement.reducer';
import { TagModule } from '../tag/tag.module';
import { AgreementRoutingModule } from './agreement-routing.module';
import { AgreementEffects } from './agreement.effects';
import { AgreementSerializer } from './agreement.serializer';
import { AgreementService } from './agreement.service';

@NgModule({
    imports: [
        CommonModule,
        AgreementRoutingModule,
        SharedModule,
        TagModule,
        StoreModule.forFeature(fromAgreement.FEATURE_NAME, fromAgreement.agreementReducer),
        EffectsModule.forFeature([AgreementEffects])
    ],
    declarations: [],
    exports: [],
    providers: [
        AgreementService,
        {
            provide: AgreementSerializer,
            useClass: AgreementSerializer
        }
    ]
})
export class AgreementModule {}
